import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorksOperationalMaterials(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIALS,
		options
	)
}
function _getDoneWorksOperationalMaterialPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIAL_PREVIEW,
		options
	)
}
function _getDoneWorksOperationalMaterialPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIAL_POPUP,
		options
	)
}

function _createDoneWorksOperationalMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].CREATE_DONE_WORKS_OPERATIONAL_MATERIAL,
		options
	)
}

function _getDoneWorksOperationalMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIAL,
		options
	)
}

function _patchDoneWorksOperationalMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].PATCH_DONE_WORKS_OPERATIONAL_MATERIAL,
		options
	)
}

function _putDoneWorksOperationalMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].PUT_DONE_WORKS_OPERATIONAL_MATERIAL,
		options
	)
}

function _deleteDoneWorksOperationalMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].DELETE_DONE_WORKS_OPERATIONAL_MATERIAL,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIALS]: _getDoneWorksOperationalMaterials,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIAL_PREVIEW]: _getDoneWorksOperationalMaterialPreview,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIAL_POPUP]: _getDoneWorksOperationalMaterialPopup,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].CREATE_DONE_WORKS_OPERATIONAL_MATERIAL]: _createDoneWorksOperationalMaterial,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].GET_DONE_WORKS_OPERATIONAL_MATERIAL]: _getDoneWorksOperationalMaterial,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].PATCH_DONE_WORKS_OPERATIONAL_MATERIAL]: _patchDoneWorksOperationalMaterial,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].PUT_DONE_WORKS_OPERATIONAL_MATERIAL]: _putDoneWorksOperationalMaterial,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].DELETE_DONE_WORKS_OPERATIONAL_MATERIAL]: _deleteDoneWorksOperationalMaterial,
}